import { useTheme } from "@/context/ThemeContext";
import { LOGOS, APP_LINKS } from "@/data/site";
import { Sun, Moon } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const Logo = ({ className = "h-12", testid = "brand-logo" }) => {
  const { theme } = useTheme();
  return (
    <img
      src={theme === "dark" ? LOGOS.dark : LOGOS.light}
      alt="AzoApp — Home Service App in Bihar, Service at Your Doorstep"
      className={`${className} w-auto object-contain select-none transition-transform duration-300 hover:scale-[1.04]`}
      draggable={false}
      data-testid={testid}
    />
  );
};

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      aria-label="Toggle theme"
      data-testid="theme-toggle-button"
      className="relative h-10 w-10 grid place-items-center rounded-full border border-azo-border glass hover:shadow-glow transition-all duration-300 group"
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={theme}
          initial={{ rotate: -90, opacity: 0, scale: 0.5 }}
          animate={{ rotate: 0, opacity: 1, scale: 1 }}
          exit={{ rotate: 90, opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.35 }}
          className="text-azo-primary"
        >
          {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
};

const PlayIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true">
    <path fill="#00E676" d="M48 59v394c0 12 13 20 24 14l232-211z" />
    <path fill="#00B0FF" d="M72 45l232 211 65-59L110 33c-14-8-38-2-38 12z" opacity="0.95" />
    <path fill="#FF3D00" d="M304 256l65-59 82 47c17 10 17 34 0 44l-82 47z" />
    <path fill="#FFD600" d="M304 256l65 59-259 165c-4 2-38 8-38-12z" opacity="0.9" />
  </svg>
);

export const PlayButton = ({ href, label = "GET IT ON", store = "Google Play", variant = "solid", testid }) => {
  const base = "group inline-flex items-center gap-3 rounded-2xl px-5 py-3 transition-all duration-300 hover:-translate-y-1";
  const styles =
    variant === "solid"
      ? "bg-azo-primary text-white hover:bg-azo-primaryh shadow-azo"
      : "border border-azo-border glass text-azo-text hover:shadow-glow";
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={`${base} ${styles}`}>
      <PlayIcon />
      <span className="flex flex-col leading-none text-left">
        <span className="text-[10px] uppercase tracking-widest opacity-70 font-mono2">{label}</span>
        <span className="text-sm font-semibold font-heading">{store}</span>
      </span>
    </a>
  );
};

export const AppButtons = ({ className = "", customerTestid = "btn-customer-app", partnerTestid = "btn-partner-app" }) => (
  <div className={`flex flex-wrap gap-3 ${className}`}>
    <PlayButton href={APP_LINKS.customer} label="BOOK A SERVICE" store="Customer App" variant="solid" testid={customerTestid} />
    <PlayButton href={APP_LINKS.partner} label="EARN AS PARTNER" store="Partner App" variant="ghost" testid={partnerTestid} />
  </div>
);
